const RESET_MESSAGES = {
  INVALID_CREDENTIALS: 'Please fill the values',
  RESET_SUCCESS: 'Mail sent successfully',
  RESET_FAILURE: 'Something went wrong, unable to sent mail',
  RESET_TOKEN_SUCCESS: 'OTP submitted successfully',
  RESET_TOKEN_FAILURE: 'Something went wrong, OTP could not be submitted',
  RESET_PASSWORD_SUCCESS: 'Your password has been updated successfully. Please proceed to login',
  RESET_PASSWORD_FAILURE: 'Reset password failed!'
};
export default RESET_MESSAGES;